import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

/**
 * imgタグに画像の比率情報等を付与
 * @param {Boolean} [isFrame=false] 画像の親要素かどうか
 * @param {Function} [callback] コールバック関数
 * @returns this
 */
$.fn.addImageRatioInfo = function addImageRatioInfo(...args) {
	const callback = u_.isFunction(args[args.length - 1]) && args.pop();
	const isFrame = args.shift();
	
	const $images = !isFrame ? this : this.children("img");
	if(!$images.length) {
		u_.isFunction(callback) && callback();
		return this;
	}
	
	const promiseList = [];
	
	$images.each((i, img) => {
		if(!isFrame && img.tagName.toLowerCase() !== "img") {
			return true;
		}
		
		const $img = $(img);
		const $frame = !isFrame ? $(img).parent() : this;
		const df = $.Deferred();
		
		$img
		.on("load", e => {
			const original = {
				h: $img.height(),
				w: $img.width()
			};
			
			const imgRatio = original.h / original.w;
			
			const attr = {
				"data-original-height": original.h,
				"data-original-width": original.w,
				"data-ratio": Math.round(imgRatio * 100) / 100
			};
			
			if(imgRatio === 1) {
				attr["data-original-shape"] = "square";
			} else {
				attr["data-original-shape"] = (imgRatio > 1) ? "vertically" : "horizontally";
			}
			
			const frameRatio = parseFloat( $frame.innerHeight() ) / parseFloat( $frame.innerWidth() );
			attr["data-fit-to"] = (imgRatio < frameRatio) ? "h" : "w";
			
			$img.attr(attr).addClass("is-loaded");
			df.resolve();
		})
		.on("error", df.resolve);
		
		promiseList.push( df.promise() );
		
		if( $img.height() ) {
			$img.trigger("load", [true]);
		} else
		if( $img.is(":hidden") ) {
			$img.trigger("error", [true]);
		}
	});
	
	u_.isFunction(callback) && $.when(...promiseList).then(callback);
	
	return this;
};
